module.exports = __webpack_public_path__ + "media/bootstrap-icons/telephone-minus-fill-a2632f19.svg";